import React from "react";
import { IconProps } from "./types";

function IconGreenCheckMarkCircle(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="#2FBF71"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8243 7.17574C19.0586 7.41005 19.0586 7.78995 18.8243 8.02426L10.0243 16.8243C9.78995 17.0586 9.41005 17.0586 9.17574 16.8243L5.17574 12.8243C4.94142 12.5899 4.94142 12.2101 5.17574 11.9757C5.41005 11.7414 5.78995 11.7414 6.02426 11.9757L9.6 15.5515L17.9757 7.17574C18.21 6.94142 18.5899 6.94142 18.8243 7.17574Z"
        fill="white"
      />
    </svg>
  );
}

export default IconGreenCheckMarkCircle;
